import { render, staticRenderFns } from "./QrcodeDialog.vue?vue&type=template&id=35c7cb57&scoped=true&"
import script from "./QrcodeDialog.vue?vue&type=script&lang=js&"
export * from "./QrcodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeDialog.vue?vue&type=style&index=0&id=35c7cb57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7cb57",
  null
  
)

export default component.exports